import renderBenefitPlanPage from "../../../infrastructure/renders/BenefitPlanPage/render-benefit-plan-page";
import {
  createBenefit,
  createBenefitModel,
  findModels,
} from "../../../infrastructure/repository/benefit-models-repository";
import { findCompanyId } from "../../../infrastructure/repository/company-repository";
import { findFreshEmployeesWithFields } from "../../../infrastructure/employees-cache";
import { parseAvailableFilters } from "../../../infrastructure/helpers/parseAvailableFilters";
import adaptBenefitPlan from "../../../infrastructure/adapters/benefit-plan/adaptBenefitPlan";
import { showErrorMessage } from "../../commons/show-error-message";
import { translate } from "../../../infrastructure/translate/localization";

export default async function createBenefitPlan({ name }) {
  await renderBenefitPlanPage({ isLoading: true });

  const companyId = await findCompanyId();
  const employees = await findFreshEmployeesWithFields(companyId);
  const { data: models } = await findModels();

  if (!models.find((model) => model.name === name)) {
    const { data } = await createBenefitModel({
      name: name.trim(),
    });

    const availableFilters = {
      ...parseAvailableFilters({
        items: employees
          .filter(({ state }) => state !== "removed")
          .map((employee) => ({
            ...employee,
            checked: false,
          })),
        properties: [
          { name: "state", translationKey: "employees-section.employee-state" },
          { name: "taxRegime", translationKey: "employees-section.tax-regime" },
          {
            name: "payrollCompany",
            translationKey: "common-messages.business-name",
          },
          { name: "costCenter", translationKey: "common-messages.cost-center" },
        ],
      }),
      model: {
        name: "modelId",
        translationKey: "benefits-section.benefit-plan",
        options: models,
      },
    };

    await renderBenefitPlanPage({
      benefitPlan: adaptBenefitPlan({ ...data.content }),
      employees: employees
        .filter(({ state }) => state !== "removed")
        .map((employee) => ({
          ...employee,
          checked: false,
        })),
      totalEmployees: employees.length,
      availableFilters,
    });
  } else {
    showErrorMessage(
      translate("benefits-section.benefit-cannot-be-named-the-same-message")
    );
    renderBenefitPlanPage({});
  }
}
